import { render, staticRenderFns } from "./provideCommunityInfo.vue?vue&type=template&id=2df87554&scoped=true&"
import script from "./provideCommunityInfo.vue?vue&type=script&lang=js&"
export * from "./provideCommunityInfo.vue?vue&type=script&lang=js&"
import style0 from "./provideCommunityInfo.vue?vue&type=style&index=0&id=2df87554&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df87554",
  null
  
)

export default component.exports